import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import { DebugView } from '@/ui';
import { KNOWN_PSAP_IDS } from '@/app/shell/knownPsapIds';
import { LoginDisplay } from '@/app/shell/LoginDisplay';
import { PsapView } from '@/app/shell/PsapConfigurationProvider';
import { WhiteLabelLogo } from '@/app/shell/WhiteLabelLogo';

function navLinkClassName({ isActive }: { isActive: boolean }): string {
  return isActive ? 'nav-link active' : 'nav-link';
}

function MyZzsNavLink() {
  return (
    <a className="nav-link" target="_blank" href="https://myzzs.zzslk.cz">
      MyZZS
    </a>
  );
}

export function MainNavigation() {
  const { t } = useTranslation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const incidentListNavLinkTitle = t('MainNavigation_IncidentList', { defaultValue: 'List of Incidents' });
  const incidentArchiveNavLinkTitle = t('MainNavigation_IncidentArchive', { defaultValue: 'Incident Archive' });
  const checklistsNavLinkTitle = t('MainNavigation_Checklists', { defaultValue: 'Checklists' });

  const hideMobileMenu = () => setMobileMenuOpen(false);
  const showMobileMenu = () => setMobileMenuOpen(true);

  return (
    <>
      <nav className="main-navigation__desktop navbar navbar-expand-tablet navbar-dark py-1 bg-psap-theme">
        <div className="container-fluid">
          <WhiteLabelLogo />
          <button className="btn btn-link text-white d-tablet-none" type="button" onClick={showMobileMenu}>
            <i className="fas fa-bars fa-xl"></i>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav me-auto">
              <li className="nav-item">
                <NavLink className={navLinkClassName} to="/incident-list">
                  {incidentListNavLinkTitle}
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className={navLinkClassName} to="/incident-archive">
                  {incidentArchiveNavLinkTitle}
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className={navLinkClassName} to="/checklists">
                  {checklistsNavLinkTitle}
                </NavLink>
              </li>
              <DebugView>
                <li className="navitem">
                  <NavLink className={navLinkClassName} to="/dev/authentication">
                    Dev
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className={navLinkClassName} to="/demo/helper">
                    Demo
                  </NavLink>
                </li>
              </DebugView>
            </ul>
            <div className="d-flex">
              <div className="navbar-nav gap-2">
                <PsapView psapId={KNOWN_PSAP_IDS.emsCzLk}>
                  <div className="nav-item">
                    <MyZzsNavLink />
                  </div>
                </PsapView>
                <LoginDisplay hideMenu={hideMobileMenu} />
              </div>
            </div>
          </div>
        </div>
      </nav>

      <div
        className={`main-navigation__mobile position-fixed ${mobileMenuOpen ? 'd-block scroll-in-navigation' : 'd-none'} start-0 end-0 top-0 bottom-0 bg-psap-theme z-3 overflow-hidden`}
      >
        <nav className="navbar navbar-expand-tablet navbar-dark py-1 bg-psap-theme">
          <div className="container-fluid">
            <WhiteLabelLogo />
            <button className="btn btn-link text-white" type="button" onClick={hideMobileMenu}>
              <i className="fas fa-xmark-large fa-xl"></i>
            </button>
          </div>
        </nav>

        <div>
          <div className="navbar-nav navbar-dark flex-column gap-2 align-items-center pt-5">
            <div className="nav-item h5">
              <NavLink to="/incident-list" onClick={hideMobileMenu} className={navLinkClassName}>
                {incidentListNavLinkTitle}
              </NavLink>
            </div>
            <div className="nav-item h5">
              <NavLink to="/incident-archive" onClick={hideMobileMenu} className={navLinkClassName}>
                {incidentArchiveNavLinkTitle}
              </NavLink>
            </div>
            <div className="nav-item h5">
              <NavLink to="/checklists" onClick={hideMobileMenu} className={navLinkClassName}>
                {checklistsNavLinkTitle}
              </NavLink>
            </div>
          </div>
          <div className="navbar-nav navbar-dark flex-column gap-1 align-items-center mt-5">
            <PsapView psapId={KNOWN_PSAP_IDS.emsCzLk}>
              <div className="nav-item">
                <MyZzsNavLink />
              </div>
            </PsapView>
            <div className="nav-item">
              <LoginDisplay hideMenu={hideMobileMenu} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
